import React, { Component } from "react";
import {
  PDFViewer,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image as RenderImage,
  BlobProvider,
} from "@react-pdf/renderer";
import { Query } from "@apollo/client/react/components";
import EnrollmentHeader from "./EnrollmentHeader";
import { PageReports } from "../../components";
import { ViewSeal } from "./ViewPartials";
import { common, layout, colors, p } from "../../styles";
import { PERSON } from "../graphql";
import {
  DEFAULT_QUERY_ERROR_POLICY,
  TRIBE_NAME,
  ENROLLMENT_DIRECTOR,
  PDF_LOADING_MESSAGE,
} from "../../../Constants";
import {
  checkForErrors,
  getPersonName,
  formatDateTime,
  formatDate,
  formatPersonExportFilename,
} from "../../../Utils";

// Create styles
const styles = StyleSheet.create({
  portrait: {
    width: "120pt",
    height: "140pt",
    borderRadius: "4pt",
    objectFit: "cover",
  },
});

// Create Document Component
export const CertificationOfIndianBloodDocument = ({ person, portrait }) => {
  return (
    <Document title="Certification of Indian Blood">
      <Page size="Letter" style={layout.page}>
        <EnrollmentHeader />
        <View style={layout.container}>
          <View style={[layout.row, common.textCenter]}>
            <Text style={[common.h1]}>CERTIFICATION OF INDIAN BLOOD</Text>
          </View>
          <View style={[layout.row, common.textCenter, p.bottom50]}>
            <Text style={common.small}>{formatDateTime(new Date())}</Text>
          </View>
          <View style={[layout.row]}>
            <View style={layout.colMd9}>
              <View style={[layout.row, p.bottom10]}>
                <Text style={[common.lead, common.bold]}>
                  TO WHOM IT MAY CONCERN:
                </Text>
              </View>
              <View style={[layout.row, p.bottom10]}>
                <Text style={[common.large, common.italic, colors.primary]}>
                  {getPersonName(person)}
                </Text>
              </View>
              <View style={[layout.row]}>
                <Text style={[common.lead, common.bold, common.uppercase]}>
                  IS AN ENROLLED CITIZEN OF THE {TRIBE_NAME} TRIBE.
                </Text>
              </View>
              <View style={[layout.row, p.bottom10]}>
                <Text style={[common.lead, common.bold]}>
                  ENROLLMENT IDENTIFICATION NUMBER:
                </Text>
              </View>
            </View>
            <View style={layout.colMd3}>
              <RenderImage src={portrait} style={styles.portrait} />
            </View>
          </View>
          <View style={[layout.row, p.bottom10]}>
            <Text style={[common.h2]}>{person.membershipNumber}</Text>
          </View>
          <View style={[layout.row, p.bottom10]}>
            <Text style={[common.lead, common.bold]}>
              DATE OF BIRTH: {formatDate(person.bornAt)}
            </Text>
          </View>
          <View style={[layout.row, p.bottom10]}>
            <Text style={[common.lead, common.bold]}>
              BLOOD DEGREE OR FAMILY TREE UPON REQUEST.
            </Text>
          </View>
          <View style={[layout.row, p.bottom50]}>
            <Text style={[common.lead, common.bold, common.uppercase]}>
              THIS PERSON IS ENTITLED TO ALL THE RIGHTS AND PRIVILEGES ACCORDING
              TO THE {TRIBE_NAME} TRIBAL CONSTITUTION AND BY-LAWS, THE LAW AND
              ORDER CODE AND THOSE RIGHTS AND PRIVILEGES HELD IN TRUST BY THE
              DEPARTMENT OF THE INTERIOR, BUREAU OF INDIAN AFFAIRS.
            </Text>
          </View>
          <View style={[layout.row, layout.spaceBetween, p.top0]}>
            <View style={[common.blankLine, p.right20, p.top5]}>
              <Text>{ENROLLMENT_DIRECTOR}, Enrollment Director</Text>
              <Text>{TRIBE_NAME}</Text>
            </View>
          </View>
          <ViewSeal />
        </View>
      </Page>
    </Document>
  );
};

class CertificationOfIndianBlood extends Component {
  constructor(props) {
    super(props);

    this.state = {
      portrait: null,
    };
  }

  componentDidMount() {
    const { person } = this._getQueryVariables();
    const url = `${
      process.env.REACT_APP_IMAGE_URL
    }/${person}.jpg?v=${Date.now()}`;

    this.setState({ portrait: url });
  }

  _getQueryVariables = () => {
    const { match } = this.props;
    let person = null;

    if (match) {
      person = match.params.person;
    }

    return { person };
  };

  render() {
    const { type } = this.props;
    const { portrait } = this.state;

    if (!portrait) {
      return null;
    }

    return (
      <Query
        query={PERSON.CERTIFICATION_OF_INDIAN_BLOOD_QUERY}
        variables={this._getQueryVariables()}
        errorPolicy={DEFAULT_QUERY_ERROR_POLICY}
      >
        {({ loading, error, data }) => {
          const loadingOrError = checkForErrors(
            loading,
            error,
            data,
            "Certification of Indian Blood"
          );
          if (loadingOrError) {
            return loadingOrError;
          }

          const { person } = data.viewer;
          const renderDocument = (
            <CertificationOfIndianBloodDocument
              person={person}
              portrait={portrait}
            />
          );

          if (type === "viewer") {
            return (
              <PageReports>
                <PDFViewer
                  style={{
                    width: "100%",
                    height: "100%",
                    border: 0,
                    maxHeight: "100%",
                    position: "absolute",
                  }}
                >
                  {renderDocument}
                </PDFViewer>
              </PageReports>
            );
          }
          return (
            <BlobProvider document={renderDocument}>
              {({ url, loading: blobLoading }) =>
                blobLoading ? (
                  PDF_LOADING_MESSAGE
                ) : (
                  <a
                    className="button"
                    href={url}
                    download={formatPersonExportFilename(person, "CIB")}
                  >
                    Certification of Indian Blood
                  </a>
                )
              }
            </BlobProvider>
          );
        }}
      </Query>
    );
  }
}

export default CertificationOfIndianBlood;
